/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../app/app.component';
import * as i4 from 'angularfire2/firestore';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'rh-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(1,49152,(null as any),0,i3.AppComponent,[i4.AngularFirestore],(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i3.AppComponent> = i1.ɵccf('rh-root',
    i3.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovQ2xpZW50cy9yZW50LWhlcm8vd2ViLWFwcGxpY2F0aW9uL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9DbGllbnRzL3JlbnQtaGVyby93ZWItYXBwbGljYXRpb24vc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vQzovQ2xpZW50cy9yZW50LWhlcm8vd2ViLWFwcGxpY2F0aW9uL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovQ2xpZW50cy9yZW50LWhlcm8vd2ViLWFwcGxpY2F0aW9uL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4iLCI8cmgtcm9vdD48L3JoLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBOzBEQUFBO1VBQUEsNkJBQStCOztRQUEvQjs7OztvQkNBQTtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/$$_gendir/app/app.component.ngfactory.ts